module.exports = __webpack_public_path__ + "media/alarm1.e24a39ca.mp3";